import ForgotPasswordTemplate from '../../components/Templates/Forgot/ForgotPasswordTemplate';
/**
 * @page ForgotPassword.tsx
 * @description Forgot Password Page.
 * @return { page }
 */
function ForgotPassword() {
  return <ForgotPasswordTemplate />;
}

export default ForgotPassword;
